// Utility functions to manage Kazoo live notes

/**
 * Remove a note from an array of notes id.
 *
 * @param noteIds - Array of notes id (i.e. Kazoo Call interaction id)
 * @param id - Kazoo Call interaction id to remove
 * @returns - Array of notes id without the id passed as parameter
 */
export const removeNoteByIndex = (noteIds: string[], id: string): string[] => {
  const indexNote = noteIds.indexOf(id)
  if (indexNote > -1) {
    const clone = [...noteIds]
    clone.splice(indexNote, 1)
    return clone
  }
  return noteIds
}
